import { TListResponse } from '.';
import {
  IncentiveStatementReportingPeriod,
  IncentiveStatementResponse,
  TClientId,
  TIncentiveStatementId,
  TIncentiveStatementReportingPeriodId,
} from '/src/lib/models';

/**
 * List Incentive Statement Reporting Periods
 */
export type TListIncentiveStatementReportingPeriodsRequest = {
  client_id: TClientId;
  page?: number;
  limit?: number;
};

export type TListIncentiveStatementReportingPeriodsResponse = TListResponse<IncentiveStatementReportingPeriod[]>;

/**
 * Get Incentive Statement Reporting Period (Combined)
 */
export type TGetIncentiveStatementReportingPeriodRequest = {
  id: TIncentiveStatementReportingPeriodId;
};

export type TGetIncentiveStatementReportingPeriodResponse = IncentiveStatementResponse;

/**
 * Get Incentive Statement (Individual Program)
 */
export type TGetIncentiveStatementRequest = {
  id: TIncentiveStatementId;
};

export type TGetIncentiveStatementResponse = IncentiveStatementResponse;
